// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"74":"1bd20f17","453":"2e02aca4","455":"041caa9d","549":"0081ced5","612":"48616106","637":"3e4b5a44","695":"c9ffdac6","784":"b4dcb7c5","897":"1a84b272","942":"608d61fc","977":"2b979af2"}[chunkId] + ".chunk.js";
};